
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="bg-white/80 backdrop-blur-md border-b border-gray-100 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <div className="relative">
              <div className="w-10 h-10 bg-gradient-to-br from-indigo-600 via-purple-600 to-indigo-800 rounded-xl flex items-center justify-center shadow-lg">
                <div className="w-6 h-6 bg-white rounded-md flex items-center justify-center">
                  <div className="w-3 h-3 bg-gradient-to-br from-indigo-600 to-purple-600 rounded-sm"></div>
                </div>
              </div>
              <div className="absolute -top-1 -right-1 w-3 h-3 bg-gradient-to-r from-yellow-400 to-orange-500 rounded-full"></div>
            </div>
            <div className="flex flex-col">
              <span className="text-xl font-bold text-gray-900 leading-tight" style={{ fontFamily: 'Inter, sans-serif' }}>
                Stupid Deep
              </span>
              <span className="text-xs font-medium text-indigo-600 -mt-1" style={{ fontFamily: 'Inter, sans-serif' }}>
                CONSULTING
              </span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link 
              to="/" 
              className={`text-sm font-medium transition-colors hover:text-indigo-600 ${
                isActive('/') ? 'text-indigo-600' : 'text-gray-700'
              }`}
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              Home
            </Link>
            <Link 
              to="/about" 
              className={`text-sm font-medium transition-colors hover:text-indigo-600 ${
                isActive('/about') ? 'text-indigo-600' : 'text-gray-700'
              }`}
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              About
            </Link>
            <Link 
              to="/services" 
              className={`text-sm font-medium transition-colors hover:text-indigo-600 ${
                isActive('/services') ? 'text-indigo-600' : 'text-gray-700'
              }`}
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              Services
            </Link>
            <Link 
              to="/case-studies" 
              className={`text-sm font-medium transition-colors hover:text-indigo-600 ${
                isActive('/case-studies') ? 'text-indigo-600' : 'text-gray-700'
              }`}
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              Case Studies
            </Link>
            <Link 
              to="/blog" 
              className={`text-sm font-medium transition-colors hover:text-indigo-600 ${
                isActive('/blog') ? 'text-indigo-600' : 'text-gray-700'
              }`}
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              Blog
            </Link>
            <Link 
              to="/contact" 
              className="bg-indigo-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-indigo-700 transition-colors whitespace-nowrap"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              Get Started
            </Link>
          </nav>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-lg text-gray-600 hover:text-gray-900 hover:bg-gray-100 transition-colors"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-100">
            <div className="flex flex-col space-y-3">
              <Link 
                to="/" 
                className={`text-sm font-medium transition-colors hover:text-indigo-600 ${
                  isActive('/') ? 'text-indigo-600' : 'text-gray-700'
                }`}
                style={{ fontFamily: 'Inter, sans-serif' }}
                onClick={() => setIsMenuOpen(false)}
              >
                Home
              </Link>
              <Link 
                to="/about" 
                className={`text-sm font-medium transition-colors hover:text-indigo-600 ${
                  isActive('/about') ? 'text-indigo-600' : 'text-gray-700'
                }`}
                style={{ fontFamily: 'Inter, sans-serif' }}
                onClick={() => setIsMenuOpen(false)}
              >
                About
              </Link>
              <Link 
                to="/services" 
                className={`text-sm font-medium transition-colors hover:text-indigo-600 ${
                  isActive('/services') ? 'text-indigo-600' : 'text-gray-700'
                }`}
                style={{ fontFamily: 'Inter, sans-serif' }}
                onClick={() => setIsMenuOpen(false)}
              >
                Services
              </Link>
              <Link 
                to="/case-studies" 
                className={`text-sm font-medium transition-colors hover:text-indigo-600 ${
                  isActive('/case-studies') ? 'text-indigo-600' : 'text-gray-700'
                }`}
                style={{ fontFamily: 'Inter, sans-serif' }}
                onClick={() => setIsMenuOpen(false)}
              >
                Case Studies
              </Link>
              <Link 
                to="/blog" 
                className={`text-sm font-medium transition-colors hover:text-indigo-600 ${
                  isActive('/blog') ? 'text-indigo-600' : 'text-gray-700'
                }`}
                style={{ fontFamily: 'Inter, sans-serif' }}
                onClick={() => setIsMenuOpen(false)}
              >
                Blog
              </Link>
              <Link 
                to="/contact" 
                className="bg-indigo-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover-bg-indigo-700 transition-colors text-center whitespace-nowrap"
                style={{ fontFamily: 'Inter, sans-serif' }}
                onClick={() => setIsMenuOpen(false)}
              >
                Get Started
              </Link>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
